import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachReservationBlock = () => {
  const page = useBrPageContext();
  if (!page) {
    return void 0;
  }
  const mainDocumentReference = page.getComponent("main")?.getModels().document;
  if (!mainDocumentReference) {
    return void 0;
  }
  if (!mainDocumentReference.$ref) {
    return void 0;
  }
  const reservationDocumentReference = getBrPageContent(
    page,
    mainDocumentReference
  )?.reservationDocument;
  if (!reservationDocumentReference) {
    return void 0;
  }
  const nextStepsWithBRProperties = getBrPageContent(
    page,
    reservationDocumentReference
  );
  const { title, reservationBlock: reservationBlockWithBRProperties } = nextStepsWithBRProperties || {};
  const reservationBlock = reservationBlockWithBRProperties?.map((block) => {
    const { title: title2, icon, text } = block;
    return { title: title2, icon, text };
  });
  return { title, reservationBlock };
};
export {
  useBloomreachReservationBlock
};
//# sourceMappingURL=use-bloomreach-reservation-block.js.map
